<table
  mat-table
  class="table-skeleton"
  [dataSource]="arrayRows">
  <ng-container matColumnDef="text">
    <td
      mat-cell
      *matCellDef="let element">
      <div class="simple-skeleton"></div>
    </td>
  </ng-container>
  <tbody>
    <tr
      mat-row
      *matRowDef="let row; columns:['text'];"></tr>
  </tbody>
</table>
